import { isValueInStepWidth } from "./isValueInStepWidth";
/**
 * Validate number input range
 *
 * @param attribute
 * @param valueText
 * @returns
 */
export function isValueInRange({ value, valueMin, valueMax, valueMinExclusive, valueMaxExclusive, valueStepWidth, }) {
    if (isNaN(value)) {
        return false;
    }
    if (valueMin != null) {
        if (valueMinExclusive ? value <= valueMin : value < valueMin) {
            return false;
        }
    }
    if (valueMax != null) {
        if (valueMaxExclusive ? value >= valueMax : value > valueMax) {
            return false;
        }
    }
    if (valueStepWidth != null) {
        return isValueInStepWidth(value, valueMin !== null && valueMin !== void 0 ? valueMin : 0, valueStepWidth);
    }
    return true;
}
//# sourceMappingURL=isValueInRange.js.map